var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 106,
    viewBox: "834 406 126 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M887.623 414.102L842 503.898L950 486.423L887.623 414.102Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M953.581 487.728L838.684 506.318L887.221 410.788L953.581 487.728ZM845.316 501.477L946.419 485.118L888.025 417.416L845.316 501.477Z",
    fill: "#9CA3AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M887.623 414.102L848.182 499.276L947.331 483.329L887.623 414.102Z",
    fill: "#DBEAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M950.915 484.636L845.025 501.667L887.147 410.703L950.915 484.636ZM851.339 496.884L943.747 482.021L888.098 417.501L851.339 496.884Z",
    fill: "#9CA3AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M890.064 434.156L867.497 485.214L924.219 476.626L890.064 434.156Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M927.696 477.981L864.426 487.56L889.598 430.61L927.696 477.981ZM870.567 482.868L920.743 475.271L890.53 437.703L870.567 482.868Z",
    fill: "#9CA3AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M896.59 469.295L892.9 469.762L893.583 475.15L897.273 474.683L896.59 469.295Z",
    fill: "#9CA3AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M892.403 465.839L889.628 450.247L894.912 449.78L896.093 465.372L892.403 465.839Z",
    fill: "#9CA3AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M927.346 457.81C937.256 457.81 945.289 449.776 945.289 439.866C945.289 429.956 937.256 421.922 927.346 421.922C917.436 421.922 909.402 429.956 909.402 439.866C909.402 449.776 917.436 457.81 927.346 457.81Z",
    fill: "#9CA3AF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M943.429 439.866C943.429 430.983 936.228 423.782 927.346 423.782C918.463 423.782 911.262 430.983 911.262 439.866C911.262 448.749 918.463 455.95 927.346 455.95C936.228 455.95 943.429 448.749 943.429 439.866ZM947.149 439.866C947.149 450.803 938.283 459.67 927.346 459.67C916.408 459.67 907.542 450.803 907.542 439.866C907.542 428.929 916.408 420.063 927.346 420.062C938.283 420.062 947.149 428.929 947.149 439.866Z",
    fill: "#9CA3AF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M928.674 456.747C938.584 456.747 946.618 448.713 946.618 438.803C946.618 428.893 938.584 420.86 928.674 420.86C918.764 420.86 910.73 428.893 910.73 438.803C910.73 448.713 918.764 456.747 928.674 456.747Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M944.758 438.803C944.758 429.92 937.557 422.72 928.674 422.72C919.791 422.72 912.59 429.92 912.59 438.803C912.59 447.686 919.791 454.887 928.674 454.887C937.557 454.887 944.758 447.686 944.758 438.803ZM948.478 438.803C948.478 449.74 939.611 458.607 928.674 458.607C917.737 458.607 908.871 449.74 908.871 438.803C908.871 427.866 917.737 419 928.674 419C939.611 419 948.478 427.866 948.478 438.803Z",
    fill: "#9CA3AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M940.21 438.803C940.21 432.432 935.045 427.267 928.674 427.267C922.303 427.267 917.138 432.432 917.138 438.803C917.138 445.175 922.303 450.34 928.674 450.34C935.045 450.34 940.21 445.175 940.21 438.803ZM941.648 438.803C941.648 445.969 935.84 451.778 928.674 451.778C921.509 451.778 915.7 445.969 915.7 438.803C915.7 431.638 921.509 425.829 928.674 425.829C935.84 425.829 941.648 431.638 941.648 438.803Z",
    fill: "#9CA3AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M931.376 443.001L928.004 443.75L928.615 446.498L931.986 445.748L931.376 443.001Z",
    fill: "#9CA3AF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M927.28 440.49L924.124 432.133L929.656 430.904L930.652 439.741L927.28 440.49Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsEmpty);
export default __webpack_public_path__ + "static/media/notificationsEmpty.9a03b5d9e792b5b55c393c868aea93cc.svg";
export { ForwardRef as ReactComponent };